const production = true;

const URL_API = production ? `https://api-website.datapar-cloud.com/open/api/` : `http://localhost:8080/api/`;
const URL_BASE = production ? `https://api-website.datapar-cloud.com/` : `http://localhost:8080/`;
const URL_API_VTIGER = production ? `https://integracion-crm.datapar-cloud.com` : `http://localhost:8000`;

export { URL_API, URL_BASE, URL_API_VTIGER }